import {
  Attachment,
  AttachmentModel,
} from '@digital-platform/attachments/domain';
import { DomainModelHelper } from '@digital-platform/shared/domain';
import { AdditionalSupplement } from '../interfaces';

export class AdditionalSupplementModel implements AdditionalSupplement {
  readonly attachment: Attachment;
  readonly comments: string;

  public static DEFAULT_CONFIG: AdditionalSupplement = {
    attachment: AttachmentModel.DEFAULT_CONFIG,
    comments: '',
  };

  constructor(config?: AdditionalSupplement) {
    this.attachment = config
      ? config.attachment
        ? new AttachmentModel(config.attachment)
        : AdditionalSupplementModel.DEFAULT_CONFIG.attachment
      : AdditionalSupplementModel.DEFAULT_CONFIG.attachment;
    this.comments = config
      ? DomainModelHelper.ensureDataIsString(config.comments)
      : AdditionalSupplementModel.DEFAULT_CONFIG.comments;
  }
}
